import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { HelmetProvider } from 'react-helmet-async'; // ✅ インポート
import './styles.css'; // ▼▼▼ この一行を追記 ▼▼▼


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider> {/* ✅ <App /> を <HelmetProvider> で囲む */}
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
